// Ideally this should be injected from ENV variable.
export const firebaseConfig = {
  apiKey: "AIzaSyBgwZuubG0UNcMR-9U4fl1NmVfwsfn1YTs",
  authDomain: "chandankumar-com.firebaseapp.com",
  databaseURL: "https://chandankumar-com.firebaseio.com",
  projectId: "chandankumar-com",
  appId: "1:288900730771:web:2791f5c1cd65607029a266",
};
